import type { IntegrationInstallInstructionsProps } from '@pages/AdminSettings/components/IntegrationTab/constants';

import { useLayoutEffect } from 'react';

export default function SlackInstallInstructions({
  onClose
}: IntegrationInstallInstructionsProps) {
  useLayoutEffect(() => {
    onClose();
    window.open(
      `https://help.streamwork.com/knowledge/how-do-i-integrate-slack-with-streamwork`,
      '_blank'
    );
  }, [onClose]);
  return null;
}
